import {API_MODULES, API_ROUTES, API_SOLUTIONS, ApiRoute} from "@api/ApiRoutes";
import {deleteRequest, getRequest, postRequest} from "@api/ApiService";
import {generateApiEndpoint} from "@api/ApiUtils";
import {
    AddToCartRequest,
    CartResponse,
    CatalogProduct,
    CatalogResponse,
    ConfirmCartRequest
} from "@lib/Catalog/CatalogModels";

const ROUTES: Record<string, ApiRoute> = {
    GET_CATALOG: {
        path: API_ROUTES.GET_CATALOG,
        module: API_MODULES.COLLECTION,
        solution: API_SOLUTIONS.MZ
    },
    GET_PRODUCT: {
        path: API_ROUTES.GET_PRODUCT,
        module: API_MODULES.COLLECTION,
        solution: API_SOLUTIONS.MZ
    },
    GET_CART: {
        path: API_ROUTES.GET_CART,
        module: API_MODULES.COLLECTION,
        solution: API_SOLUTIONS.MZ
    },
    REMOVE_CART_ITEM: {
        path: API_ROUTES.REMOVE_CART_ITEM,
        module: API_MODULES.COLLECTION,
        solution: API_SOLUTIONS.MZ
    },
    ADD_TO_CART: {
        path: API_ROUTES.ADD_TO_CART,
        module: API_MODULES.COLLECTION,
        solution: API_SOLUTIONS.MZ
    },
    CONFIRM_CART: {
        path: API_ROUTES.CONFIRM_CART,
        module: API_MODULES.COLLECTION,
        solution: API_SOLUTIONS.MZ
    }
}

class CatalogService {

    static getCatalog = async (size: number = 250): Promise<CatalogResponse> => {

        return await getRequest<CatalogResponse>(generateApiEndpoint(ROUTES.GET_CATALOG), {params: {page: 0, size, sort: "position"}});

    }

    static getProduct = async (productId: string): Promise<CatalogProduct> => {

        return await getRequest<CatalogProduct>(generateApiEndpoint({
            ...ROUTES.GET_PRODUCT,
            params: {productId}
        }));

    }

    static getCart = async (): Promise<CartResponse> => {

        return await getRequest<CartResponse>(generateApiEndpoint(ROUTES.GET_CART), {
            params: {
                basketType: "BASKET_PURCHASE"
            }
        });

    }

    static removeCartItem = async (catalogGroupProductLogicId: string): Promise<any> => {

        return await deleteRequest<any>(generateApiEndpoint({
            ...ROUTES.REMOVE_CART_ITEM,
            params: {catalogGroupProductLogicId}
        }), {
            params: {
                catalogGroupProductLogicId: catalogGroupProductLogicId,
                basketType: "BASKET_PURCHASE"
            }
        });

    }

    static addToCart = async (payload: AddToCartRequest): Promise<CartResponse> => {

        return await postRequest<CartResponse, AddToCartRequest>(generateApiEndpoint(ROUTES.ADD_TO_CART), payload, {
            params: {
                basketType: "BASKET_PURCHASE"
            }
        });

    }

    static confirmCart = async (payload: ConfirmCartRequest): Promise<any> => {

        return await postRequest<any, ConfirmCartRequest>(generateApiEndpoint(ROUTES.CONFIRM_CART), payload, {
            params: {
                basketType: "BASKET_PURCHASE"
            }
        });

    }
}

export default CatalogService;